'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/pow.js
// module id = 1544
// module chunks = 8